module.exports = __webpack_public_path__ + "img/prescription1.dd3fc171.png";